<template>
  <f7-page>
    <f7-navbar :title="$t('title.manageTags')" :back-link="$t('action.back')">
    </f7-navbar>
    <div v-if="$store.state.tags.tags.length">
      <f7-list v-if="$store.state.tags.tags.length">
        <ul>
          <f7-list-item group-title title="Tags"/>
          <manage-tags-tag v-for="tag in realTags"
                           :key="tag.name"
                           :tag="tag"
          />
          <f7-list-item group-title title="Pseudo-Tags"/>
          <f7-list-item divider class="detail">
            These are tags that have been entered by your users that you have not explicitly added.
            If they are heavily used you might consider adding them explicitly.
          </f7-list-item>
          <manage-tags-tag v-for="tag in pseudoTags"
                           :key="tag.name"
                           :tag="tag"
          />
        </ul>
      </f7-list>
    </div>
    <f7-block v-else>
      {{$t('text.noTags')}}
    </f7-block>
    <f7-fab position="center-bottom" @click="onAdd">
      <f7-icon ios="f7:plus" md="material:add"/>
    </f7-fab>
  </f7-page>
</template>

<script>
  import ManageTagsTag from '@/components/ManageTagsTag'

  export default {
    name: 'ManageTags',
    components: {ManageTagsTag},
    data () {
      return {}
    },
    methods: {
      onAdd () {
        const prompt = this.$f7.dialog.prompt('Enter a tag name:', this.$t('title.addTag'),
          async name => await this.$store.dispatch('tags/add', name)
        )
        prompt.el.querySelector('input').focus()
      },
    },
    computed: {
      realTags () {
        return this.$store.state.tags.tags.filter(t => !t.pseudo)
      },
      pseudoTags () {
        return this.$store.state.tags.tags.filter(t => t.pseudo)
      },
    },
    async mounted () {
      await this.$store.dispatch('tags/fetch')
    },
  }
</script>

<style scoped>

  .detail {
    height: auto !important;
    line-height: unset !important;
    white-space: unset;
    overflow: auto;
    padding-bottom: 1em !important;
  }

</style>
